import {
    CleaningProperties,
    DeviceSettingsGeneralConfiguration,
    QcProperties,
} from '../settings-device-configuration-status-tracking/settings-device-configuration-status-tracking.model';
import { DeviceConfigurationInstance } from '../settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import {
    CleaningPropertiesAPI,
    DeviceSettingsGeneralConfigurationAPI,
    EditDeviceConfigurationAPI,
    QcPropertiesAPI,
} from './device-settings-config.api';

export const mapSettingsDeviceConfigurationModelToApi = (
    settings: DeviceConfigurationInstance
): EditDeviceConfigurationAPI => ({
    id: settings.id,
    description: settings.description,
    properties: Object.keys(settings.properties)
        .filter((value) => settings.properties[value] != null)
        .map((property) => ({
            name: property,
            values: Array.isArray(settings.properties[property])
                ? settings.properties[property]
                : [settings.properties[property] as string],
        })),
});

const mapCleaningPropertiesFromApi = (cleaning: CleaningPropertiesAPI | null): CleaningProperties | undefined =>
    cleaning
        ? {
              ...cleaning,
              showOperatorComments: cleaning.showOperatorComments ?? undefined,
              supportsOperatorComments: cleaning.showOperatorComments !== null,
          }
        : undefined;

export const mapCleaningPropertiesSettingsToApi = (cleaning: CleaningProperties): CleaningPropertiesAPI => ({
    enabled: cleaning.enabled,
    warningHours: cleaning.warningHours,
    overdueHours: cleaning.overdueHours,
    showOperatorComments: cleaning.showOperatorComments ?? null,
});

export const mapGeneralDeviceSettingsConfiguration = (
    config: DeviceSettingsGeneralConfigurationAPI
): DeviceSettingsGeneralConfiguration => ({
    ...config,
    qcProperties: {
        ...config.qcProperties,
        days: Math.floor(Number(config.qcProperties.value) / 24),
        hours: Number(config.qcProperties.value) % 24,
    },
    cleaningProperties: mapCleaningPropertiesFromApi(config.cleaningProperties),
});

export const mapQcPropertiesSettingsToApi = (qcProperties: QcProperties): QcPropertiesAPI => ({
    enabled: qcProperties.enabled,
    levels: qcProperties.levels,
    qcType: qcProperties.qcType,
    value: String(qcProperties.days * 24 + qcProperties.hours),
});
